export enum Origin{
    FANAR = "fanar",
}

export enum RateLimitModelType {
  FANAR = "Fanar",
  FANAR_S_1_7B = "Fanar-S-1-7B",
  FANAR_C_1_87B = "Fanar-C-1-8.7B",
  ISLAMIC_RAG = "Islamic-RAG",
  FANAR_ORYX_IVU_1 = "Fanar-Oryx-IVU-1",
  FANAR_IMAGE_GEN_1 = "Fanar-ImageGen-1",
  FANAR_SHAHEEN_MT_1 = "Fanar-Shaheen-MT-1",
  FANAR_AURA_TTS_1 = "Fanar-Aura-TTS-1",
  FANAR_AURA_STT_1 = "Fanar-Aura-STT-1",
  FANAR_AURA_STT_LF_1 = "Fanar-Aura-STT-LF-1"
}